var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeoutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "timeout-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36CECE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30C6E2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "88.8384086%",
    x2: "0%",
    y2: "11.1615914%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36CECE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30C6E2",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "timeout-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-clock",
    transform: "translate(35.000000, 31.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6,0.4 C6.6,0.4 0.2,6.8 0.2,14.8 C0.2,22.8 6.6,29.2 14.6,29.2 C22.6,29.2 29,22.8 29,14.8 C29,6.8 22.6,0.4 14.6,0.4 Z M19.4,16.4 L14,16.4 C13.4,16.4 13,16 13,15.4 L13,8.4 C13,7.5 13.7,6.8 14.6,6.8 C15.5,6.8 16.2,7.5 16.2,8.4 L16.2,13.2 L19.4,13.2 C20.3,13.2 21,13.9 21,14.8 C21,15.7 20.3,16.4 19.4,16.4 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "car",
    opacity: 0.4,
    transform: "translate(0.000000, 3.000000)",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9863281,0 C44.7109375,0 48.9746094,3.01785714 50.4726562,7.66071429 L50.4726562,7.66071429 L54.2753906,19.0357143 C57.0410156,20.1964286 59,22.8660714 59,26 L59,26 L59.0007636,28.155564 C56.2897399,26.4116604 53.0630129,25.4 49.6,25.4 C40.0187182,25.4 32.2461796,33.1441501 32.200205,42.7146295 L11.0625,42.7142857 L11.0625,48.2857143 C11.0625,50.375 9.44921875,52 7.375,52 L7.375,52 L3.6875,52 C1.61328125,52 0,50.375 0,48.2857143 L0,48.2857143 L0,26 C0,22.8660714 1.95898438,20.1964286 4.72460938,19.0357143 L4.72460938,19.0357143 L8.52734375,7.66071429 C10.0253906,3.01785714 14.2890625,0 19.0136719,0 L19.0136719,0 Z M11.0625,26 C8.98828125,26 7.375,27.625 7.375,29.7142857 C7.375,31.8035714 8.98828125,33.4285714 11.0625,33.4285714 C13.1367188,33.4285714 14.75,31.8035714 14.75,29.7142857 C14.75,27.625 13.1367188,26 11.0625,26 Z M39.9863281,7.42857143 L19.0136719,7.42857143 C17.4003906,7.42857143 16.0175781,8.47321429 15.5566406,9.98214286 L15.5566406,9.98214286 L12.6757812,18.5714286 L46.3242188,18.5714286 L43.4433594,9.98214286 C42.9824219,8.47321429 41.5996094,7.42857143 39.9863281,7.42857143 L39.9863281,7.42857143 Z",
    id: "Combined-Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeoutIcon);
export default __webpack_public_path__ + "static/media/timeout-icon.8369d1bb6234ea75ed2a2ff67dd40a98.svg";
export { ForwardRef as ReactComponent };